__turbopack_context__.v({
  "label": "Jq9K4G_label",
  "shimmer": "Jq9K4G_shimmer",
  "termsAndConditions": "Jq9K4G_termsAndConditions",
  "text-bar-sweep": "Jq9K4G_text-bar-sweep",
});
